/* global localData */
const checkoutTotalPriceEl = document.querySelector('.purchase-process-04__footer .footer-price h2');
const checkoutTaxEl = document.querySelector('.purchase-process-04__footer .footer-tax');

/// Stripe ///
// This is a public sample test API key.
// Don’t submit any personally identifiable information in requests made with this key.
// Sign in to see your own test API key embedded in code samples.
let stripe;
if (document.querySelector('section.sc-purchase-process-04')) {
  if (typeof localData === 'object') {
    stripe = Stripe(localData.stripeKey, {
      locale: 'sl',
    });
  }
}

let elements;
let voucherCodeData;

// Fetches a payment intent and captures the client secret
async function initializeStripe() {
  const {clientSecret} = await fetch(`${localData.siteURL}?action=createStripeClientKey`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
  }).then((r) => r.json());

  elements = stripe.elements({clientSecret});

  localData.clientSecret = clientSecret;

  const paymentElement = elements.create('payment');
  paymentElement.mount('#payment-element');
}

// ------- UI helpers -------

function showMessage(messageText) {
  const messageContainer = document.querySelector('#payment-message');

  messageContainer.classList.remove('hidden');
  messageContainer.textContent = messageText;

  setTimeout(() => {
    messageContainer.classList.add('hidden');
    // eslint-disable-next-line no-param-reassign
    toggleLoader(false);
  }, 2000);
}

async function handleSubmitStripe(e) {
  e.preventDefault();
  const consentCheckbox = document.querySelector('.footer-checkbox input[name="checkbox"]');
  if (!consentCheckbox.checked) {
    consentCheckbox
      .closest('.checkbox')
      .querySelector(
        '.fv-plugins-message-container',
      ).innerHTML = `<div data-field='checkbox' data-validator='notEmpty'>Za nadaljevanje se morate strinjati s pogoji. </div>`;
  }
  if (consentCheckbox.checked) {
    toggleLoader(true);
    const {paymentIntent} = await stripe.retrievePaymentIntent(localData.clientSecret);
    const newsletterCheckbox = document.querySelector('.footer-checkbox input[type="checkbox"]:checked#newsletter_checkbox');
    const axiosData = new FormData();
    axiosData.append('action', 'createOrderFromCartItems');
    axiosData.append('type', 'stripe');
    axiosData.append('stripePaymentIntentId', paymentIntent.id);
    axiosData.append('stripePaymentIntentSecret', paymentIntent.client_secret);
    if (newsletterCheckbox) {
      axiosData.append('checkbox_newsletter', true);
    }
    axios.post(localData.siteURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const {error} = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${localData.siteURL}?action=updateOrderStatus`,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === 'card_error' || error.type === 'validation_error' || error.type === 'invalid_request_error') {
      const axiosDataFail = new FormData();
      axiosDataFail.append('action', 'updateOrderStatus');
      axiosDataFail.append('type', 'stripe');
      axiosDataFail.append('status', 'failed');
      axiosDataFail.append('code', error.code);
      axiosDataFail.append('decline_code', error.decline_code);
      axiosDataFail.append('stripePaymentIntentId', paymentIntent.id);
      axiosDataFail.append('stripePaymentIntentSecret', paymentIntent.client_secret);
      axios
        .post(localData.siteURL, axiosDataFail, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            window.location.href = response.data.data.url;
          }
        })
        .catch(() => {
          toggleLoader(false);
        });
      showMessage(error.message);
    } else {
      showMessage('An unexpected error occurred.');
    }
  }
}

const handleSubmitProformaInvoice = (e) => {
  e.preventDefault();
  const consentCheckbox = document.querySelector('.footer-checkbox input[name="checkbox"]');
  if (!consentCheckbox.checked) {
    consentCheckbox
      .closest('.checkbox')
      .querySelector(
        '.fv-plugins-message-container',
      ).innerHTML = `<div data-field='checkbox' data-validator='notEmpty'>Za nadaljevanje se morate strinjati s pogoji. </div>`;
  }
  if (consentCheckbox.checked) {
    const newsletterCheckbox = document.querySelector('.footer-checkbox input[type="checkbox"]:checked#newsletter_checkbox');
    toggleLoader(true);
    const axiosData = new FormData();
    axiosData.append('action', 'createOrderFromCartItems');
    if (newsletterCheckbox) {
      axiosData.append('checkbox_newsletter', true);
    }
    axios
      .post(localData.siteURL, axiosData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          window.location.href = response.data.data.url;
        }
      })
      .catch((error) => {
        toggleLoader(false);
      });
  }
};

const handleSubmitLeanpay = (e) => {
  e.preventDefault();
  const consentCheckbox = document.querySelector('.footer-checkbox input[name="checkbox"]');
  if (!consentCheckbox.checked) {
    consentCheckbox
      .closest('.checkbox')
      .querySelector(
        '.fv-plugins-message-container',
      ).innerHTML = `<div data-field='checkbox' data-validator='notEmpty'>Za nadaljevanje se morate strinjati s pogoji. </div>`;
  }
  if (consentCheckbox.checked) {
    toggleLoader(true);
    const newsletterCheckbox = document.querySelector('.footer-checkbox input[type="checkbox"]:checked#newsletter_checkbox');
    const axiosData = new FormData();
    axiosData.append('action', 'createOrderFromCartItems');
    axiosData.append('type', 'leanpay');
    if (newsletterCheckbox) {
      axiosData.append('checkbox_newsletter', true);
    }
    axios
      .post(localData.siteURL, axiosData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          window.location.href = response.data.data.url;
        }
      });
  }
};

const handleSubmitPreventDefault = (e) => {
  e.preventDefault();
};

const submitButton = document.querySelector('.purchase-process-04__footer .btn--default');
if (submitButton) {
  submitButton.addEventListener('click', handleSubmitPreventDefault);

  submitButton.addEventListener('click', () => {
    const parent = submitButton.closest('.purchase-process-04');
    const method = parent.querySelector('.payment-method.is-active');

    if (!method) {
      parent.classList.add('is-validation-failed');
    }
  });
}

const checkoutPage = document.querySelector('.sc-purchase-process-04');
if (checkoutPage) {
  window.onpopstate = () => {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  };
}

const process04Methods = document.querySelectorAll('.purchase-process-04__payment-methods .payment-method__header');
process04Methods.forEach((process04Method) => {
  process04Method.addEventListener('click', () => {
    const otherParents = process04Method.closest('.purchase-process-04__payment-methods');
    const otherMethods = otherParents.querySelectorAll('.payment-method');
    otherMethods.forEach((otherMethod) => {
      otherMethod.classList.add('is-hidden');
      submitButton.addEventListener('click', handleSubmitPreventDefault);
      submitButton.removeEventListener('click', handleSubmitStripe);
      submitButton.removeEventListener('click', handleSubmitProformaInvoice);
    });

    const parent = process04Method.closest('.payment-method');
    parent.classList.remove('is-hidden');
    parent.classList.add('is-active');
    if (parent.classList.contains('stripe')) {
      initializeStripe();
      submitButton.removeEventListener('click', handleSubmitPreventDefault);
      submitButton.addEventListener('click', handleSubmitStripe);
    } else if (parent.classList.contains('proforma-invoice')) {
      submitButton.removeEventListener('click', handleSubmitPreventDefault);
      submitButton.addEventListener('click', handleSubmitProformaInvoice);
    } else if (parent.classList.contains('leanpay')) {
      submitButton.removeEventListener('click', handleSubmitPreventDefault);
      submitButton.addEventListener('click', handleSubmitLeanpay);
    }

    const closeMethod = parent.querySelector('.payment-method__content-close');

    closeMethod.addEventListener('click', () => {
      otherMethods.forEach((otherMethod) => {
        submitButton.removeEventListener('click', handleSubmitStripe);
        submitButton.removeEventListener('click', handleSubmitProformaInvoice);
        submitButton.removeEventListener('click', handleSubmitLeanpay);
        submitButton.addEventListener('click', handleSubmitPreventDefault);
        otherMethod.classList.remove('is-hidden');
        parent.classList.remove('is-active');
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const purchaseProcess04Checkbox = document.querySelectorAll('.purchase-process-04 .footer-checkbox');
  if (purchaseProcess04Checkbox) {
    window.onpopstate = () => {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    };
    purchaseProcess04Checkbox.forEach((el) => {
      const fv = FormValidation.formValidation(el, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: {},
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) => element.closest('.checkbox'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      });
    });
  }
});

// update total price and tax
const updateTotalCheckoutPrice = (totalPrice) => {
  const checkoutTax = totalPrice - totalPrice * 0.22;
  setPriceInEuro(checkoutTotalPriceEl, totalPrice);
  setPriceInEuro(checkoutTaxEl, checkoutTax, ' brez DDV');
};

// Voucher Code
// get voucher cookie
const getVoucherCookie = () => {
  const cookies = document.cookie.split(';');
  let vouchers = null;
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('vouchers=')) {
      vouchers = cookie.substring('vouchers='.length, cookie.length);
      break;
    }
  }
  return vouchers;
};

// Add Voucher Code Axios
const axiosCalculateTotals = () => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'calculateTotals');
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// Add Voucher Code Axios
const axiosAddVoucher = (promoParent) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'addVoucher');
  formDataInput.append('inputs', JSON.stringify(voucherCodeData));
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        const addVoucherCodeEl = promoParent;
        const addVoucherErrorEl = promoParent.querySelector('.promo-code__error');
        const addVoucherSuccessEl = promoParent.querySelector('.promo-code__success');
        const addVoucherDiscountEl = promoParent.querySelector('.promo-code__discount');
        const addVoucherCodeSubmit = promoParent.querySelector('.promo-code__submit');
        const addVoucherCodeInputEl = promoParent.querySelector('.mod-input__field');

        // success
        addVoucherCodeSubmit.disabled = false;
        if (response.data.data.voucher_valid) {
          addVoucherCodeSubmit.classList.add('delete');
          addVoucherCodeEl.classList.add('is-active', 'is-success');
          addVoucherSuccessEl.innerText = response.data.data.response_text;
          addVoucherDiscountEl.innerText = response.data.data.coupon_amount;
          addVoucherErrorEl.innerText = '';
          updateTotalCheckoutPrice(response.data.data.updated_total_price);

          const voucherObj = {
            id: response.data.data.voucher_id,
            code: response.data.data.voucher_code,
          };

          let vouchers = getVoucherCookie();
          if (vouchers) {
            vouchers = decodeURIComponent(vouchers);
            vouchers = JSON.parse(vouchers);
            vouchers.push(voucherObj);
          } else {
            vouchers = [voucherObj];
          }

          axiosCalculateTotals();
          setCookie('vouchers', encodeURIComponent(JSON.stringify(vouchers)));
          addVoucherCodeEl.dataset.voucher = response.data.data.amount;
          document.querySelector('.purchase-process-01__promo-codes').insertAdjacentHTML('beforeend', response.data.data.html_voucher);
        } else {
          addVoucherCodeEl.classList.add('is-error');
          addVoucherErrorEl.innerText = response.data.data.response_text;
          addVoucherSuccessEl.innerText = '';
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// Remove Voucher Code Axios
const axiosRemoveVoucher = (promoParent) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'removeVoucher');
  formDataInput.append('inputs', JSON.stringify(voucherCodeData));
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      const thisCodeEl = promoParent;
      const thisSuccessEl = promoParent.querySelector('.promo-code__success');
      const thisDiscountEl = promoParent.querySelector('.promo-code__discount');
      const thisCodeSubmit = promoParent.querySelector('.promo-code__submit');
      const thisCodeInputEl = promoParent.querySelector('.mod-input__field');
      if (response.status === 200) {
        if (response.data.data.voucher_valid) {
          // success
          document.querySelector('.promo-code.promo-code--voucher:not(.is-active)').remove();
          thisCodeSubmit.disabled = false;
          thisDiscountEl.innerText = '';
          thisCodeInputEl.value = '';
          thisSuccessEl.innerText = response.data.data.response_text;
          thisCodeSubmit.classList.remove('delete');
          thisCodeEl.classList.remove('is-active');
          updateTotalCheckoutPrice(response.data.data.updated_total_price);

          // remove specific voucher from cookie
          const voucherObj = {
            id: response.data.data.voucher_id,
            code: response.data.data.voucher_code,
          };

          let vouchers = getVoucherCookie();
          if (vouchers) {
            vouchers = decodeURIComponent(vouchers);
            vouchers = JSON.parse(vouchers);
            vouchers = vouchers.filter((item) => item.id !== voucherObj.id);
          }

          // if empty remove cookie
          if (vouchers.length === 0) {
            deleteCookie('vouchers');
          } else {
            setCookie('vouchers', encodeURIComponent(JSON.stringify(vouchers)));
          }

          axiosCalculateTotals();
          promoParent.removeAttribute('data-voucher');
          document.querySelector('.purchase-process-01__promo-codes').appendChild(promoParent);
        } else {
          thisCodeSubmit.disabled = false;
          thisSuccessEl.innerText = response.data.data.response_text;
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// Validate Voucher Code Input
const validateVoucherCodeAndProcess = (addCodeText, addValidCodeText, add, element) => {
  const promoCodeParent = element.closest('.promo-code');
  const voucherInput = promoCodeParent.querySelector('.mod-input__field').value.replace(/(<([^>]+)>)/gi, '');
  const voucherInputEmpty = voucherInput.length < 1;
  const voucherInputInvalid = !/^[a-zA-Z0-9-]+$/.test(voucherInput);
  if (voucherInputEmpty || voucherInputInvalid) {
    promoCodeParent.classList.add('is-error');
    promoCodeParent.querySelector('.promo-code__error').innerText = voucherInputEmpty ? addCodeText : addValidCodeText;
  } else {
    voucherCodeData = {
      code: voucherInput,
    };
    promoCodeParent.querySelector('.promo-code__submit').disabled = true;
    if (add) {
      axiosAddVoucher(promoCodeParent);
    } else {
      axiosRemoveVoucher(promoCodeParent);
    }
  }
};

// Add Voucher Code
attachEvent('.promo-code--voucher .promo-code__submit:not(.delete)', 'click', (ev) => {
  validateVoucherCodeAndProcess('Vnesite kodo za darilni bon', 'Vnesite veljavno kodo za darilni bon', true, ev.target);
});

// Remove Voucher Code
attachEvent('.promo-code--voucher .promo-code__submit.delete', 'click', (ev) => {
  validateVoucherCodeAndProcess(
    'Vnesite kodo za odstranitev darilnega bon',
    'nesite veljavno kodo za odstranitev darilnega bona',
    false,
    ev.target,
  );
});
